import global from "@/locales/en-IE/global";
import error403 from "@/locales/en-IE/errors/403";
import error404 from "@/locales/en-IE/errors/404";
import error500 from "@/locales/en-IE/errors/500";
import error503 from "@/locales/en-IE/errors/503";
import error504 from "@/locales/en-IE/errors/504";
import maintenance from "@/locales/en-IE/auth/maintenance";
import toast from "@/locales/en-IE/toast/toast";
import login from "@/locales/en-IE/auth/login";
import onboarding from "@/locales/en-IE/auth/onboarding";
import loginPageSteps from "@/locales/en-IE/loginPageSteps";
import dashboard from "@/locales/en-IE/dashboard/dashboard";
import staff from "@/locales/en-IE/dashboard/staff";
import promotions from "@/locales/en-IE/promotions";
import points from "@/locales/en-IE/points";
import account from "@/locales/en-IE/account/account";
import mailbox from "@/locales/en-IE/account/mailbox";
import bankstatement from "@/locales/en-IE/account/bankstatement";
import myApps from "@/locales/en-IE/my-apps/myApps";
import about from "@/locales/en-IE/about/about";
import contactService from "@/locales/en-IE/about/contactService";
import salesPromotions from "@/locales/en-IE/sales/promotions";
import brochures from "@/locales/en-IE/sales/brochures";
import shop from "@/locales/en-IE/shop/data";
import priceList from "@/locales/en-IE/shop/priceList";
import trainings from "@/locales/en-IE/trainings/trainings";
import vouchers from "@/locales/en-IE/vouchers/vouchers";
import media from "@/locales/en-IE/media/index";
import product from "@/locales/en-IE/product/index";
import message from "@/locales/en-IE/message/index";
import commitmentLetter from "@/locales/en-IE/account/commitmentLetter";
import multiplicator from "@/locales/en-IE/multiplicator";
import widgets from "@/locales/en-IE/widgets/widgets";
import consents from "@/locales/en-IE/consents/consents";
import investment from "@/locales/en-IE/investment/data";
import kickback from "@/locales/en-IE/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Product Images",
    BDriveLinkText: "Link to the PRODUCT IMAGES portal",
  },
}

export default {
  locale: "en-IE",
  messages,
};
